export default __webpack_public_path__ + "static/media/shot-5.1a19d50a.png";